import Immutable from 'immutable';
import { socialLinks } from '../../data/social';

const socialLinkList = (state = new Immutable.Map(), action) => {
  return state.merge(
    Immutable.fromJS(
      socialLinks.reduce((map, property) => {
        map[property.id] = property;
        return map;
      }, {})
    )
  );
};

export default socialLinkList;
